module.exports = __webpack_public_path__ + "media/images/w_2-b464602510ef2500b328f5fe26b01479.png";